import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { get } from '../../../server/actions';
import { groupBy, showFile, _addNotificationError } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import TmExportExcel from '../../Misc/tmExportExcel/tmExportExcel';
import tempEligibilityReportIcon from './../../../assets/img/mm/icon-9.png';
class TempEligibilityReport extends Component {
    constructor(props){
        super(props);
        this.state={
            startDate: new Date(),
            endDate:new Date(),
            tempEligibilityData:[],
            userInfo: getLoginDistrictInfo(),
        }
    }
    componentWillMount=()=>{
         this.getTempEligibilityData();
     }
     componentWillReceiveProps=(nextProps)=>{
        if(nextProps.selectSchool!=this.props.selectSchool){
            this.getTempEligibilityData();
        }        
    }
     
    getSystemDateTime = (date) =>{        
        let _datetime=moment(date,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")
        return _datetime;
    }
     bindData=()=>{
         const districtID = this.state.userInfo.districtId;
         let schoolID = parseInt(this.props.selectSchool);
         const s_d_id=schoolID>0?schoolID:districtID;
         const schoolYear = this.props.selectedSchoolYear || this.state.userInfo.schools[0].activeSchoolYear;        
         let _url='';
        const isDistId=schoolID>0?false:true
        _url=`/reports/fmActualReport?mealSchoolId=${s_d_id}&isDistId=${isDistId}&fileType=pdf&isTemp=true&schoolYear=${schoolYear}&access_token=`;
         
         this.setState({loading: true})
         get(_url).then((response) => {
             if (!response.ok) {
                 if(response.status===417|| response.status===422){
                     return response.json();
                 }
             }
             console.log('response', response);
             return response;
         }).then(res => {
             if(res.statusCode===417){
                 _addNotificationError(res.statusMessage,this.props)
                     throw Error(res.errorMessage);
                 }else if(res.statusCode===422){
                     throw Error(res.statusMessage);
                 }else{
                     return res.blob();                
                 } 
         }).then(blob => {
             let filename = "TempEligibilityReport";
             showFile(blob,filename);            
                 this.setState({loading: false})
             }).catch((error) => {
                 let msg=''
                 if(typeof error==='string'){
                     msg=error;
                 }else{
                     msg=error.message;
                 }
                 _addNotificationError(msg,this.props);
                 this.setState({loading: false})
             }
         );
     }
     getTempEligibilityData = () => {
        this.setState({loading:true})
        const schoolID = parseInt(this.props.selectSchool);
        const districtID = this.state.userInfo.districtId 
        const schoolYear = this.props.selectedSchoolYear || this.state.userInfo.schools[0].activeSchoolYear
        const s_d_id=schoolID>0?schoolID:districtID
        const isDistId=schoolID>0?false:true
        const _url=`/reports/fmActualReport?mealSchoolId=${s_d_id}&isDistId=${isDistId}&fileType=AllData&isTemp=true&schoolYear=${schoolYear}&access_token=`;
       get(_url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            const resData=(data.response||[])
            this.setState({ tempEligibilityData: resData, loading:false})
        }).catch(error => {
            this.setState({ tempEligibilityData: [], loading:false})
            console.log("Loading Report Failed", error)
        })
    };
     buildDataFormatForExport=()=>{
        const gradesMap=this.state.userInfo.gradesMap||[];
        const gradeGroup=groupBy(gradesMap,'value');
        return (
            [{
              columns: [{title:'SCHOOL'},{title:'PARENT EMAIL'},{title: 'STUDENT ID'}, {title: 'NAME'}, {title: 'GRADE'},
              {title: 'TEACHER'},{title: 'ELIGIBILITY'}],
              data: this.state.tempEligibilityData.map(item => {
                  return [{value: item.schoolName||''},{value:item.parentEmail||''},{value: item.studentId || ''}, {value: `${item.studentLName||''} ${item.studentFName||''}`}, {value: `${((gradeGroup[item.gradeName] || [])[0] || {}).label || ''}`}
                  , {value: item.teacherName || ''}, {value: `${(item.freeMeal) === true ? 'FreeMeals' : (item.reducedPrice)===true? 'ReducedPrice':'RegularPrice'}`}]
              })
            }]
        );
    }
    render() {
        return (
            <Fragment>
                <div className="reportCard reportCard-margin">
                    <div className="reportCard-body">
                        <div className="reportCard-widget">
                            <div className="reportCard-widget-title-wrapper">
                                <div className="reportCard-widget-date-primary"> 
                                <img src={tempEligibilityReportIcon} />                                                                                    
                                </div>
                                <div className="reportCard-widget-meeting-info">
                                    <span className="reportCard-widget-pro-title color-3"><b>Temp Eligibility Report</b></span>                                                    
                                </div>
                            </div>                                            
                        <div className="reportCard-widget-meeting-points">
                        </div>
                        <div className='reportCard-widget-meeting-action'>
                            <div className="form-group">
                                <button type='button' className='btn btn-sm btn-success' style={{margin:'0px 5px 0px 0px'}} onClick={()=>{
                                    this.bindData()
                                }}>
                                    Download Report
                                </button>
                                <TmExportExcel
                                id={"tempEligibilityReport"} 
                                name={"TempEligibilityReport"}
                                filename={"Temp Eligibility Report"}
                                element={<button type='button' id={"tempEligibilityReport"} className="btn btn-warning btn-sm" style={{margin:'0px'}}><i className="fa fa-file-excel-o"></i> Export</button>}
                                dataSet={this.buildDataFormatForExport()}
                            />
                            </div>                        
                        </div>
                    </div>
                </div>
                </div> 
            </Fragment>
        );
    }
}

export default TempEligibilityReport;


// WEBPACK FOOTER //
// ./src/components/District/Reports/tempEligibilityReport.js